import { ThresholdData } from '@cmps/ng-kit';

import { bgGradient } from '../../common/pipe/bg-gradient';
import { Mi2DataResult } from '../models/mi2-data-result';

export function getProgressDataMi2(
    mi2DataResult: Mi2DataResult,
): ThresholdData[] {
    const score = mi2DataResult?.miScoreDataList?.[0]?.actual ?? 0;
    const defaultColor = '#000000';

    const thresholds = mi2DataResult?.mi2KpiThreshold ?? [];

    const totalRange = Math.min(
        thresholds[thresholds.length - 1]?.rangeEnd ?? 100,
        100,
    );

    return thresholds.map((threshold, index) => {
        const startValue = index === 0 ? 0 : thresholds[index - 1].rangeEnd;
        const endValue = Math.min(threshold.rangeEnd ?? totalRange, totalRange);
        const color = threshold.rangeColour ?? defaultColor;

        const widthPercentage = ((endValue - startValue) / totalRange) * 100;

        return {
            color,
            colorGradient: bgGradient({ color }),
            startValue,
            endValue,
            width: widthPercentage,
            enabled: score >= startValue && score < endValue,
        };
    });
}
